/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Badge, Spin } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/react-components';
import { PulseLoader } from 'react-spinners';
import { AtbdTopDropdwon, BagdeWrapper, BagdeWrapper2 } from './auth-info-style';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import { Cards } from '../../cards/frame/cards-frame';
import { NEWS_BY_SYMBOLS } from '../../../graphql-query/graphql-query';
import { setActiveLayoutAction, setDailogStatusAction } from '../../../redux/pricingLayoutDailog/actionCreator';
import { setNotificationGraphData } from '../../../redux/notification/actionCreator';

const NewsBox = () => {
  const Symbol = useSelector(state => state.symbolData);
  const [showPopover, togglePopoverView] = useState(false);
  const { loading, error, data } = useQuery(NEWS_BY_SYMBOLS, {
    variables: { symbolId: Symbol.selectedSymbol.id },
  });
  const dispatch = useDispatch();
  const [newsState, setNewsState] = useState({
    key: 0,
  });
  const [activeNewsPage, setActiveNewsPage] = useState([0, 4]);
  const [count, setCount] = useState(0);
  const { rtl } = useSelector(state => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
    };
  });

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: 'rgb(72 136 243 / 50%)',
    };
    return <div style={{ ...style, ...thumbStyle }} props={props} />;
  };

  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      opacity: 1,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };

  const checkIfNewsIsMoreThen2DaysOld = date => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const interval = seconds / 86400;
    if (interval <= 2) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (data && data.core_news && !loading) {
      if (data.core_news.length > 0) {
        var countVar = 0;
        for (let i = 0; i < data.core_news.length; i++) {
          if (checkIfNewsIsMoreThen2DaysOld(data.core_news[i].date) === true && countVar < 10) {
            countVar += 1;
          } else {
            setCount(countVar);
            break;
          }
        }
      }
    }
  }, [data, loading]);

  const loadNextNews = params => {
    if (data && data.core_news.length > activeNewsPage[1]) {
      setActiveNewsPage([activeNewsPage[0], activeNewsPage[1] + 4]);
    } else {
      setActiveNewsPage([0, 4]);
    }
    if (params === 'reset') {
      setActiveNewsPage([0, 5]);
    }
  };

  const onClickViewAnalysis = newObject => {
    dispatch(setActiveLayoutAction('news'));
    dispatch(setNotificationGraphData(newObject));
    dispatch(setDailogStatusAction(true));
    togglePopoverView(false);
  };

  const onTouchMailIcon = () => {
    if (showPopover === false) {
      togglePopoverView(true);
    } else {
      togglePopoverView(false);
    }
    loadNextNews('reset');
  };

  const renderView = ({ style, ...props }) => {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div {...props} style={{ ...style, ...customStyle }} />;
  };

  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon">
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <div className="atbd-top-dropdwon-menu">
          <ul className="atbd-top-dropdwon__nav" style={{ height: 'auto' }}>
            {Symbol.selectedSymbol.id && data ? (
              data.core_news.slice(activeNewsPage[0], activeNewsPage[1]).map((x, i) => {
                return (
                  <li key={x.id} onClick={() => onClickViewAnalysis(x)}>
                    <div
                      className="atbd-top-dropdwon__content notifications"
                      style={{ padding: '13px 10px', paddingLeft: '0px' }}
                    >
                      <div className="notification-icon bg-primary">
                        <FeatherIcon icon="mail" />
                      </div>
                      <div className="notification-content d-flex">
                        <div className="notification-text">
                          <Heading as="h5">
                            <div
                              style={{ color: '#8a8fa5', cursor: 'pointer' }}
                              onClick={() => onClickViewAnalysis(x)}
                            >{`${x.title}, `}</div>
                          </Heading>
                          <p>{x.date.slice(0, 10)}</p>
                        </div>
                        <div className="notification-status">
                          {checkIfNewsIsMoreThen2DaysOld(x.date) ? <Badge dot /> : <></>}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="sd-spin">
                <PulseLoader color="#4285f4" loading size={15} aria-label="Loading Spinner" data-testid="loader" />
              </div>
            )}
          </ul>
          {data && data.core_news.length > 0 && data.core_news.length > activeNewsPage[1] ? (
            <Link
              className="btn-seeAll"
              style={{ width: '100%', color: '#4285f4' }}
              to="/"
              onClick={() => loadNextNews('next')}
            >
              {data.core_news.length > activeNewsPage[1] ? <>Load More News</> : <></>}
            </Link>
          ) : (
            <></>
          )}
        </div>
      </Scrollbars>
    </AtbdTopDropdwon>
  );

  return (
    <div className="message">
      <Popover placement="bottomLeft" content={content} action="click" visible={showPopover}>
        {count >= 9 ? (
          <BagdeWrapper2>
            <Badge count={count} showZero overflowCount={9}>
              <Link to="/dashboard" onClick={onTouchMailIcon} className="head-example">
                <FeatherIcon icon="rss" size={24} />
              </Link>
            </Badge>
          </BagdeWrapper2>
        ) : (
          <BagdeWrapper>
            <Badge count={count} overflowCount={9}>
              <Link to="/dashboard" onClick={onTouchMailIcon} className="head-example">
                <FeatherIcon icon="rss" size={24} />
              </Link>
            </Badge>
          </BagdeWrapper>
        )}
      </Popover>
    </div>
  );
};

NewsBox.propTypes = {
  rtl: PropTypes.bool,
};

export default NewsBox;
